import _ from 'lodash'

const readOnlyDirective = function ($animate, userService) {
  return {
    transclude: 'element',
    replace: true,
    priority: 601,
    restrict: 'A',
    compile: (element, attr, transclude) => ($scope, $element, $attr) => {
      const u = userService.getCurrentUser()
      const readOnly = _.includes(u.permissions, 'ReadOnly');

      if (!readOnly) {
        const childScope = $scope.$new();
        transclude(childScope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  }
}


angular.module('clientDashboardApp').directive('excludeReadOnly', readOnlyDirective);

